import { render, staticRenderFns } from "./item-weight-bar.vue?vue&type=template&id=31bccdac&scoped=true&functional=true&"
import script from "./item-weight-bar.vue?vue&type=script&lang=js&"
export * from "./item-weight-bar.vue?vue&type=script&lang=js&"
import style0 from "./item-weight-bar.vue?vue&type=style&index=0&id=31bccdac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "31bccdac",
  null
  
)

export default component.exports